<template>
  <FaLayer v-tooltip="tooltip">
    <FaIcon v-if="selectedIcon?.icon"
      :class="{
        ['IconColor IconColor--'+selectedIcon?.color]: selectedIcon?.color,
        [selectedIcon?.class]: selectedIcon?.class
      }"
      :mask="selectedIcon?.mask || null"
      :icon="selectedIcon?.icon"
      :transform="selectedIcon?.transform || null"
      :opacity="selectedIcon?.opacity || null"
      :style="selectedIcon?.style || {}"
      />
    <FaIcon
      v-if="selectedIcon?.subIcon"
      :class="{
        ['IconColor IconColor--'+selectedIcon?.subColor]: selectedIcon?.subColor,
        ['IconColor IconColor--'+selectedIcon?.color]: !selectedIcon?.subColor,
        [selectedIcon?.subClass]: selectedIcon?.subClass
      }"
      :icon="selectedIcon?.subIcon"
      :mask="selectedIcon?.subMask && ['fas', selectedIcon?.subMask] || null"
      :transform="selectedIcon?.subTransform || null"
      :opacity="selectedIcon?.subOpacity || null"
      :style="selectedIcon?.subStyle || null"
    />
  </FaLayer>
</template>

<script lang="ts">
import { mixinFaIcons, mixinStatusProps } from '@/icons/mixins';
import { getPwaStatusIcon } from '@/config/pwa';
import { isBoolean } from '@/functions/boolean';
import { APP_NAME } from '@/config/app';
import { defineComponent } from 'vue';

export default defineComponent({
  mixins: [mixinFaIcons],
  props: { ...mixinStatusProps },
  methods: {
    isBoolean
  },
  computed: {
    selectedIcon() {
      const selected = getPwaStatusIcon(this.status)

      const reversedIcon = !!selected.mask;

      return {
        ...selected,
        icon: reversedIcon ? selected.mask : selected.icon,
        mask: reversedIcon ? selected.icon : selected?.mask,
      }
    },
    tooltip() {
      const { selectedIcon, disabled } = this
      if (disabled || !selectedIcon?.value) return false
      return {
        triggers: ['click', 'hover', 'focus'],
        content: `${APP_NAME}: ${selectedIcon?.tooltip}`,
      }
    }
  }
});
</script>
